<template>
  <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
    <svg width="40" height="40" class="text-blue-500">
      <circle
        cx="20"
        cy="20"
        r="18"
        stroke="currentColor"
        stroke-width="4"
        fill="none"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="dashOffset"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ProgressCircle',

  props: {
    progress: {
      type: Number,
      required: true
    }
  },
  computed: {
    radius() {
      return 18;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    dashOffset() {
      return this.circumference * (1 - this.progress / 100);
    }
  }
}
</script>